import React from "react";

import "./styles.scss";

const FlipButton = (props) => {
  const label = props.buttonText ? props.buttonText : "Enter now";

  return (
    <div className="flip-button" onClick={props.onClick}>
      <div className="flip-button-inner">
        <div className="flip-button-front">
          <span className="button-inner">{label}</span>
        </div>
        <div className="flip-button-back">
          <span className="button-inner">{label}</span>
        </div>
      </div>
    </div>
  );
};

export default FlipButton;
